import { ProductError, ProductErrorType } from '../../models';

export class SpacerData {
  height: SpacerHeight;
  horizontal: boolean;
  width?: number;
  color?: string; // Hexadecimal
  thickness?: number;

  constructor(data?: SpacerData) {
    this.height = data.height ?? SpacerHeight.S;
    this.horizontal = data.horizontal ?? false;
    this.width = data.width ?? null;
    this.color = data.color ?? null;
    this.thickness = data.thickness ?? null;
  }

  static validate(spacerData: SpacerData, payloadData: any): ProductError[] {
    if (!spacerData) {
      return [{ type: ProductErrorType.MISSING, property: 'spacer', payload: { ...payloadData } }];
    }
    const productErrors: ProductError[] = [];
    if (spacerData.horizontal) {
      if (!spacerData.color) {
        SpacerData.pushError(productErrors, ProductErrorType.MISSING, 'color', payloadData);
      }
      SpacerData.validateWidth(spacerData.width, productErrors, payloadData);
      SpacerData.validateThickness(spacerData.thickness, productErrors, payloadData);
    }
    return productErrors;
  }

  static validateWidth(width: number, productErrors: ProductError[], payloadData: any): void {
    if (!width) {
      SpacerData.pushError(productErrors, ProductErrorType.MISSING, 'width', payloadData);
    } else if (width > 100 || width < 1) {
      SpacerData.pushError(productErrors, ProductErrorType.OUT_OF_RANGE, 'width', payloadData);
    }
  }

  static validateThickness(thickness: number, productErrors: ProductError[], payloadData: any): void {
    if (!thickness) {
      SpacerData.pushError(productErrors, ProductErrorType.MISSING, 'thickness', payloadData);
    } else if (thickness > 100 || thickness < 1) {
      SpacerData.pushError(productErrors, ProductErrorType.OUT_OF_RANGE, 'thickness', payloadData);
    }
  }

  static pushError(productErrors: ProductError[], type: ProductErrorType, property: string, payloadData: any): void {
    productErrors.push({
      type,
      property,
      payload: { ...(payloadData ? payloadData : {}) },
    });
  }
}

export enum SpacerHeight {
  S = 's',
  M = 'm',
  L = 'l',
}
